"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeCategoryDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _hooks = require("../../state/redux/hooks");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _common = require("./common");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _featureFlags = require("../../utils/featureFlags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const TypeCategoryDropdown = _ref => {
  let {
    name,
    onChange,
    selectedTypeCategoryId,
    className,
    disabled,
    invalid = false
  } = _ref;
  const issueCategories = (0, _hooks.useSelector)(_issueTypes.getIssueTypeCategories);
  const issueCategoryOptions = (0, _react.useMemo)(() => (0, _common.getIssueTypeCategoriesAsOptions)(issueCategories), [issueCategories]);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  let {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase2Batch3);
  shouldUseNewDropdown = true;
  const OldDropdown = () => /*#__PURE__*/React.createElement(_SelectBoxWrapper.SelectBoxWrapper, {
    invalid: invalid,
    name: name,
    className: className,
    value: selectedTypeCategoryId ? {
      value: selectedTypeCategoryId
    } : null,
    maxMenuHeight: 150,
    searchable: true,
    placeholder: T.translate("issueTypesAdmin.categoryPlaceholder"),
    options: issueCategoryOptions,
    onChange: onChange ? option => {
      onChange(option.value);
    } : undefined,
    disabled: disabled
  });
  const semanticIdentifier = "type-category-dropdown";
  const NewDropdown = () => {
    // must be referential equality
    const selectedOption = selectedTypeCategoryId ? issueCategoryOptions.find(item => item.value === selectedTypeCategoryId) : null;
    const {
      controlProps,
      menuProps: allMenuProps
    } = (0, _alloyReactDropdown.useAutocomplete)({
      items: issueCategoryOptions,
      defaultSelectedItem: selectedOption,
      selectedItem: selectedOption,
      onSelectedItemChange: _ref2 => {
        let {
          selectedItem
        } = _ref2;
        return onChange && selectedItem ? onChange(selectedItem.value) : undefined;
      },
      id: semanticIdentifier
    });
    const {
      menuItems,
      getItemProps,
      ...menuProps
    } = allMenuProps;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_alloyReactDropdown.AutocompleteControl, _extends({}, controlProps, {
      disabled: disabled,
      placeholder: T.translate("issueTypesAdmin.categoryPlaceholder"),
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/React.createElement(_alloyReactDropdown.AutocompleteMenu, _extends({}, menuProps, {
      style: {
        maxHeight: 150
      },
      "data-testid": "".concat(semanticIdentifier, "-menu")
    }), menuItems.map((item, index) => /*#__PURE__*/React.createElement(_alloyReactDropdown.MenuItem, _extends({
      key: index
    }, getItemProps === null || getItemProps === void 0 ? void 0 : getItemProps({
      item
    }))))));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.TypeCategoryDropdown = TypeCategoryDropdown;
//# sourceMappingURL=TypeCategoryDropdown.js.map